module.exports = __webpack_public_path__ + "img/supplyChain-demonstration-L.23206ed9.png";